export default __webpack_public_path__ + "static/media/tower_logo_white.d64ba55a.png";